import { apiFetch } from "./api";

export interface ManifestModule {
  id: string;
  label: string;
  description: string;
  icon: string;
  entrypoint: string;
  order?: number;
  is_favorite?: boolean;
}

export function getAllModules() {
  return apiFetch<ManifestModule[]>(`/api/manifest/modules`);
}

export function executeManifestQuery<T>(
  moduleId: string,
  queryId: string,
  params: object,
  clientId: string,
) {
  return apiFetch<T>(`/api/manifest/modules/${moduleId}/queries/${queryId}/execute`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: { "X-Client-ID": clientId },
  });
}
